import * as React from "react";
import "./EditMessage.scss";

interface EditMessageProps {
  forModal: boolean;
  onMessageDataChange: any;
    initialMessage: string;
    type: string;
}

export default function EditMessage(props: EditMessageProps) {
  const { onMessageDataChange, forModal } = props;
  const [comment, setComment] = React.useState("");
  const [commentCount, setCommentCount] = React.useState(0);
  const [activeHeader, setActiveHeader] = React.useState("comment");
  React.useEffect(() => {
    validateForm();
  }, [comment]);

  const handleHeaderClick = (headerType: string) => {
    setActiveHeader(headerType);
  };

  const stripHtmlTags = (input: string) => {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.body.textContent || "";
  };

  const handleComment = (event: any) => {
    // Strip HTML from the input value
    let sanitizedText = stripHtmlTags(event.target.value);
    sanitizedText = sanitizedText.replace(/['";]/g, '');
    event.target.value = sanitizedText;
    setComment(event.target.value);
    setCommentCount(event.target.value.length);
  };

  const validateForm = () => {
    if (commentCount >= 10) {
      //valid
      sendData(true);
    } else {
      //Invalid
      sendData(false);
    }
  };

  const sendData = (isValidComment: boolean) => {
    if (isValidComment) {
      const messageData = {
        isValidComment: isValidComment,
        comment: comment,
      };
      onMessageDataChange(messageData);
    } else {
      const messageData = {
        isValidComment: isValidComment,
      };
      onMessageDataChange(messageData);
    }
  };

  const generatePlaceholderText = () => {
    if(props.type == null) {
      return "Enter the reason for reopening this event";
    }
    else if(props.type == "closing") {
      return "Enter the reason for closing this event";
    }
    else if(props.type == "") {
      return "Typed here a public message that every department associated with this event can see.";
    }  
  };

  document.querySelectorAll('textarea').forEach(element => {
    element.style.height = `${element.scrollHeight}px`;
    element.addEventListener('input', event => {
        event.target.style.height = 'auto';
        event.target.style.height = `${event?.target?.scrollHeight}px`;
    })
});

return (
  <div className={forModal ? 'reopen-container reopening' :'newcomment-container'}>
      {activeHeader === 'comment' &&
          <>
              <main>
                 { forModal && (  
                   <div>
                        <span className="reopen-text">Reason for {props.type == null ? "reopening" : props.type} the event</span>
                    </div>
                 )}
                 { !forModal && (
                  <div className='tabs-header'>
                      <span className={`edit-message-item ${activeHeader === 'comment' ? 'active' : ''}`} onClick={() => handleHeaderClick('comment')} role="button" tabIndex={0} onKeyDown={(e) => { if(e.key === 'Enter'){ handleHeaderClick('comment') }}}>Comment</span>
                  </div> )}
                  <textarea rows={1} className="data p" name="art" id="art_reopen"
                    onInput={handleComment} value={comment} placeholder={generatePlaceholderText()} />
                  <div className="label-comment edit-comment-label" slot="helptext">{`${commentCount} characters (minimum 10 characters)`}</div>
              </main>
          </>
      }

  </div>
);
}